module.exports = __webpack_public_path__ + "img/potion_img_08.587d8bb7.png";